import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { BrandStore } from './context';

const FAVICON_PATH = `/public`;

export const HTMLHead: React.FunctionComponent = () => {
  // Step 1. Get context brand favicon.
  const {
    state: { brand },
  } = useContext(BrandStore);
  const [faviconWeb] = brand?.faviconWeb || [];
  const faviconWebUrl = faviconWeb?.url || null;
  const title = brand?.platformName
    ? `Registration | ${brand.platformName}`
    : 'Registration';

  // Defaults.
  let appleTouchIcon = `${FAVICON_PATH}apple-touch-icon.png`;
  let icon32x32 = `${FAVICON_PATH}favicon-32x32.png`;
  let icon16x16 = `${FAVICON_PATH}favicon-16x16.png`;
  let shortcutIcon = `${FAVICON_PATH}favicon.ico`;

  // Step 2. Override with airtable's favicon.
  if (faviconWebUrl) {
    appleTouchIcon = icon32x32 = icon16x16 = shortcutIcon = faviconWebUrl;
  }

  return (
    <Helmet defaultTitle={title}>
      <meta name="apple-mobile-web-app-capable" content="yes" />
      {/* Begin icons */}
      <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
      <link rel="icon" type="image/png" sizes="32x32" href={icon32x32} />
      <link rel="icon" type="image/png" sizes="16x16" href={icon16x16} />
      <link rel="shortcut icon" href={shortcutIcon} />
      {/* End icons */}
    </Helmet>
  );
};
